import { render, staticRenderFns } from "./DrawerBrokenTab.vue?vue&type=template&id=bfb2357c&scoped=true"
import script from "./DrawerBrokenTab.vue?vue&type=script&lang=js"
export * from "./DrawerBrokenTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerBrokenTab.vue?vue&type=style&index=0&id=bfb2357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2357c",
  null
  
)

export default component.exports